module.exports = __webpack_public_path__ + "static/ecanta-digital-marketing-5bc2c56256b3234c5c1b4b0e026f988d.png";